import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import { envP } from '../../utils/environments';
import loginLeftBg from '../../static/images/login_left_bg.png';
import loginRightBg from '../../static/images/login_right_bg.png';

const useStyle = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'fixed',
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
     backgroundColor: ({ env }) => {
      if (env === envP.PPS) {
        return '#f18740';
      }
      return theme.palette.primary.main;
    },
    overflow: 'auto',
  },
  leftBg: {
    position: 'absolute',
    height: '37rem',
    left: 0,
    bottom: 0,
    width: '50%',
    background: `url(${loginLeftBg}) left bottom no-repeat`,
    backgroundSize: 'contain',
  },
  rightBg: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: '21.625rem',
    width: '50%',
    background: `url(${loginRightBg}) right top no-repeat`,
    backgroundSize: 'contain',
  },
  title: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '2.25rem',
    fontWeight: 'bold',
    color: theme.palette.font.white,
    marginBottom: '0.983rem',
  },
  subTitle: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.25rem',
    fontWeight: 500,
    marginBottom: '2.439rem',
    color: theme.palette.font.white,
  },
}));

export default function LoginBg({ children, title, subTitle }) {
  const classes = useStyle();

  return (
    <div className={classes.root}>
      <div className={classes.leftBg} />
      <div className={classes.rightBg} />
      <Typography className={classes.title}>{title}</Typography>
      <Typography className={classes.subTitle}>{subTitle}</Typography>
      {children}
    </div>
  );
}
